import { lighten, darken } from '@material-ui/core/styles/colorManipulator';
import * as colors from '../common/colors';

export default {
  type: 'dark',
  common: {
    black: colors.black,
    white: colors.white,
    neutral: colors.grey['200'],
    muted: colors.grey['500'],
  },
  primary: {
    contrastText: colors.white,
    main: '#454DCC',
    light: lighten('#454DCC', 0.2),
    dark: darken('#454DCC', 0.35),
  },
  error: {
    contrastText: colors.white,
    main: colors.red,
    light: lighten(colors.red, 0.3),
    dark: darken(colors.red, 0.15),
  },
  secondary: {
    contrastText: colors.white,
    main: '#2AA5EA',
    light: lighten('#2AA5EA', 0.3),
    dark: darken('#2AA5EA', 0.15),
  },
  success: {
    contrastText: colors.white,
    main: colors.green,
    light: lighten(colors.green, 0.3),
    dark: darken(colors.green, 0.15),
  },
  info: {
    contrastText: colors.white,
    main: colors.blue,
    light: lighten(colors.blue, 0.3),
    dark: darken(colors.blue, 0.15),
  },
  warning: {
    contrastText: colors.white,
    main: colors.orange,
    light: lighten(colors.orange, 0.35),
    dark: lighten(colors.orange, 0.1),
  },
  danger: {
    contrastText: colors.white,
    main: colors.red,
    light: lighten(colors.red, 0.3),
    dark: darken(colors.red, 0.15),
  },
  text: {
    primary: colors.white,
    secondary: colors.grey[200],
    contrast: '#12161B',
    disabled: colors.grey[300],
  },
  background: {
    default: colors.grey[800],
    inverted: colors.grey[200],
  },
  border: colors.grey[800],
  divider: colors.grey[300],
};
